import { useState, useEffect } from 'react';
import PromoCode from "./PromoCode/ProductOfferPromoCode";
// TODO: Switch back to real PromoCode when API is ready
// import PromoCode from "../Order/Payment/PromoCode";
import WhoIsItFor from "./WhoIsItFor";
import RelatedOffers from "./RelatedOffers/RelatedOffers";
import Variants from "./Variants/Variants"; 
// grouped section: component for tabbed group layout
import VariantGroups from "./Variants/VariantGroups";
import useBodyClass from "../../Hooks/useBodyClass";
import { HeadingBanner } from "./PromoBanner/HeadingBanner";
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useObserver from '../../Hooks/useObserver';
import SearchDropdown from '../UI/Dropdown/SearchDropdown';

import '../../i18n'
import './ProductOffer.scss'
import './PromoCode/ProductOfferPromoCode.scss'
import { Basket } from '../Order/Payment/Basket';
import { APIGet, APIPost } from '../API/APIRequest';
import { GetADToken } from '../Utilities/TokenManager';
 

export function ProductOffer(){
    useBodyClass("product-variants");
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [productVariants, setProductVariants] = useState([]);
    const [basket, setBasket] = useState({});
    const [usePromoCode, setUsePromoCode] = useState(false);
    const [promoApplied, setPromoApplied] = useState(null);
    const [isMultiVariant, setIsMultiVariant] = useState(false);
    const [variantStyle, setVariantStyle] = useState("card");
    // grouped section: toggles tabbed group layout with image and features per group
    const [isGrouped, setIsGrouped] = useState(false);
    const [groupNavStyle, setGroupNavStyle] = useState("tabbed");

    // Reset groupNavStyle to tabbed when style is not pill
    useEffect(() => {
        if (variantStyle !== "pill") {
            setGroupNavStyle("tabbed");
        }
    }, [variantStyle]);

    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("United Kingdom");
    const [isSearchableCountry, setIsSearchableCountry] = useState(true);
    const [showSidebar, setShowSidebar] = useState(false);
    const [showMobileBasket, setShowMobileBasket] = useState(false);
    const [showWhoIsItFor, setShowWhoIsItFor] = useState(false);
    const [recipient, setRecipient] = useState("");

    // Track window width for responsive inputSize on country dropdown
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const countryInputSize = windowWidth >= 480 ? "large" : "medium";

    // Embed mode: ?embedComponents=variants hides banner and toolbar, shows only variant cards
    const searchParams = new URLSearchParams(window.location.search);
    const isEmbedVariantsOnly = searchParams.get("embedComponents") === "variants";
    const showBanner = !isEmbedVariantsOnly;
    const showToolbar = !isEmbedVariantsOnly;
    // Read offerId from query param (used for related offers and future offer-specific variant loading)
    const [offerId, setOfferId] = useState(searchParams.get("offerId") || null);
    //identify the object we want to be observed and if is visible on the screen (threshold is if is 50% visible )
    const [obserRef, isVisible] = useObserver();

    useEffect(() => {
        getBasket();
    }, [updating])

  let { fid } = useParams();

    const getBasket = () => {

        if (!fid || basket?.id) {
            fid = basket.id;
        }
        
        APIGet({
            "controller": "basket",
            "action": "getbasket",
            "environment": null,
            "identifier": fid
        }).then((response) => {
            if (response.data.success) {

                setBasket(response.data.basket);
            
                if (!fid) {
                    var newPath = window.location.protocol + "//" + window.location.host;
                    if (window.location.pathname) {
                        newPath += window.location.pathname;
                    }
                    newPath += "/" +response.data.basket.id;
                    window.history.pushState({ path: newPath }, '', newPath);
                }

            }
            else {
                //setErrors(response.data.errors);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    } 
 

    useEffect(() => {
        const loadData = async () => {
            const params = {};
            if (offerId) {
                params.offerId = offerId;
            }
            APIGet({
                "controller": "product",
                "action": "getproductvariants",
                "environment": null,
                "data": params
            }).then((response) => {
                if (response.data?.success) {
                    setProductVariants(response.data.variants);
                    // Update offerId from server response (priority offer resolution)
                    if (response.data.offerId && !offerId) {
                        setOfferId(response.data.offerId);
                    }
                } else {
                    setProductVariants(response.data || []);
                }
            }).catch(() => {
                setProductVariants([]);
                setLoading(false);
            });
        }
        loadData();
    }, [offerId]);

    useEffect(() => {
        APIGet({
            "controller": "country",
            "action": "getcountries",
            "environment": null,
            "identifier": null
        }).then((response) => {
            const sorted = response.data.countries.sort((a, b) => {
                if (a.countryname < b.countryname) return -1;
                if (a.countryname > b.countryname) return 1;
                return 0;
            });
            setCountries(sorted);
        });
    }, []);

 
 
  

    const addToBasket = (id, quantity = 1) => {
        var data = new FormData();
        
        data.append("productVariantId", id);
        data.append("quantity", quantity);
      

        APIPost({
            "controller": "basket",
            "action": "addtobasket",
            "environment": null,
            "identifier": basket.id,
            "data": data
        }).then((response) => { 
            setBasket(response.data.basket);
            setUpdating(!updating);
        });  
    }

    const reduceFromBasket = (id, quantity = 1) => {
        var data = new FormData();
        
        data.append("productVariantId", id);
        data.append("quantity", quantity);

        APIPost({
            "controller": "basket",
            "action": "reduceitemquantity",
            "environment": null,
            "identifier": basket.id,
            "data": data
        }).then((response) => { 
            setBasket(response.data.basket);
            setUpdating(!updating);
        });  
    }
 
 
   
        // Determine the purchasing target and route, then redirect
        const navigateToCheckout = (purchasingFor) => {
            const adtoken = GetADToken();
            let redirectUrl = "";

            // Determine route based on basket flags (same logic as LandingPage)
            if (basket?.offertypename === "corporate subscription") {
                redirectUrl = "/payment/";
            } else if (basket?.allowguestcheckout && !basket?.allowcustomercheckout && !adtoken) {
                redirectUrl = "/guest/";
            } else {
                redirectUrl = "/payment/";
            }

            redirectUrl += basket.id + "?purchasingFor=" + purchasingFor;
            window.location.href = redirectUrl;
        }

        // Show WhoIsItFor popup OR go straight to checkout based on basket flags
        const Checkout = () => {
            // Corporate subscription → always self, skip popup
            if (basket?.offertypename === "corporate subscription") {
                navigateToCheckout("self");
                return;
            }

            // Both gifting and individual allowed → show WhoIsItFor popup
            if (basket?.allowindividualcheckout && basket?.allowgifting) {
                setShowWhoIsItFor(true);
                return;
            }

            // Only gifting allowed → auto-set gift, skip popup
            if (basket?.allowgifting && !basket?.allowindividualcheckout) {
                navigateToCheckout("gift");
                return;
            }

            // Only individual allowed (or neither flag set) → auto-set self, skip popup
            navigateToCheckout("self");
        }

        // Called from WhoIsItFor popup after user selects recipient
        const proceedToCheckout = () => {
            setShowWhoIsItFor(false);
            const purchasingFor = recipient || "unknown";
            navigateToCheckout(purchasingFor);
        }
        

 
 
    const handleUsePromo = (ev)=>{
        ev.preventDefault()
        setUsePromoCode((prev) => !prev)
    }
    return(
        <div className="container-wrapper">
            <div className="container">
                {showBanner && <HeadingBanner offerId={offerId} />}
                {showToolbar && <div className={`item-container ${usePromoCode ? "productoffer-toolbar-expanded" : ""}`}>
                    <div className="item-wrapper module-row">

                        {// <Promo fid={fid} setActionName={setActionName} adToken={adToken} purchasingFor={purchasingFor} deliveryCountryCode={deliveryCountryCode} variantIdForPromoCode={variantIdForPromoCode} updateAndRefreshBasket={updateAndRefreshBasket} basket={basket} />
                        }
       
                        <div className="field-wrapper promo-code-wrapper productoffer-toolbar">
                            <div className="field-item">
                                {promoApplied ? (
                                    <div className="promo-applied-tag">
                                        <div className="tag-icon"><img src={require("../UI/Icons/tag.svg").default} alt="promo" /></div>
                                        <span className="promo-tag-code">{promoApplied}</span>
                                        <button className="promo-tag-remove" onClick={() => { setPromoApplied(null); setUsePromoCode(false); }} aria-label="Remove promo code"><div className="close-promo-icon"><img src={require("../UI/Icons/close-icon-dark.svg").default} alt="remove" /></div></button>
                                    </div>
                                ) : (
                                    <>
                                        <a href="./" onClick={handleUsePromo}>{usePromoCode ? "Hide promo code" : "Enter a promo code"} </a>
                                    </>
                                )}
                                {usePromoCode && !promoApplied && <div className="productoffer-promo-input"><PromoCode onApplied={(code) => { setPromoApplied(code); setUsePromoCode(false); }} /></div>}
                            </div>
                            <div className="productoffer-country-selector">
                                {isSearchableCountry ? (
                                    <SearchDropdown
                                        id="productoffer-country"
                                        name="productoffer-country"
                                        inputFieldType="text"
                                        inputSize={countryInputSize}
                                        placeholder="Search"
                                        setValue={(value) => setSelectedCountry(value?.countryname)}
                                        val={selectedCountry}
                                        options={countries}
                                        dropdownName="country"
                                        keyProperty="countrycode"
                                        nameProperty="countryname"
                                        valueProperty="countrycode"
                                    />
                                ) : (
                                    <SearchDropdown
                                        id="productoffer-country"
                                        name="productoffer-country"
                                        inputFieldType="text"
                                        inputSize={countryInputSize}
                                        placeholder={selectedCountry}
                                        setValue={(value) => setSelectedCountry(value?.countryname)}
                                        val={selectedCountry}
                                        options={countries}
                                        dropdownName="country"
                                        keyProperty="countrycode"
                                        nameProperty="countryname"
                                        valueProperty="countrycode"
                                        readOnly
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>}
                {/*
                    <Variants
                        productVariants={productVariants}
                        setStyle="blockStyle"
                />
                     <Variants
                            productVariants={productVariants}
                            setStyle="listStyle"
                        />
                    */
                }
                {/* Floating sidebar toggle */}
                <button className="sidebar-toggle-btn" onClick={() => setShowSidebar(prev => !prev)}>⚙</button>
                <div className={`productoffer-sidebar ${showSidebar ? "open" : ""}`}>
                    <div className="sidebar-header">
                        <h4>Display Settings</h4>
                        <button className="sidebar-close" onClick={() => setShowSidebar(false)}>✕</button>
                    </div>
                    <div className="sidebar-section">
                        <label>Style</label>
                        <div className="sidebar-buttons">
                            <button className={variantStyle === "card" ? "active" : ""} onClick={() => setVariantStyle("card")}>card</button>
                            <button className={variantStyle === "list" ? "active" : ""} onClick={() => setVariantStyle("list")}>list</button>
                            <button className={variantStyle === "pill" ? "active" : ""} onClick={() => setVariantStyle("pill")}>pill</button>
                        </div>
                    </div>
                    <div className="sidebar-section">
                        <label>Mode</label>
                        <div className="sidebar-buttons">
                            <button className={!isMultiVariant ? "active" : ""} onClick={() => setIsMultiVariant(false)}>subscribe</button>
                            <button className={isMultiVariant ? "active" : ""} onClick={() => setIsMultiVariant(true)}>multi-variant</button>
                        </div>
                    </div>
                    <div className="sidebar-section">
                        <label>Grouping</label>
                        <div className="sidebar-buttons">
                            <button className={!isGrouped ? "active" : ""} onClick={() => setIsGrouped(false)}>ungrouped</button>
                            <button className={isGrouped ? "active" : ""} onClick={() => setIsGrouped(true)}>grouped</button>
                        </div>
                    </div>
                    <div className="sidebar-section">
                        <label>Group Nav</label>
                        <div className="sidebar-buttons">
                            <button disabled={!isGrouped || variantStyle !== "pill"} className={groupNavStyle === "tabbed" && isGrouped && variantStyle === "pill" ? "active" : ""} onClick={() => setGroupNavStyle("tabbed")}>tabbed</button>
                            <button disabled={!isGrouped || variantStyle !== "pill"} className={groupNavStyle === "card" && isGrouped && variantStyle === "pill" ? "active" : ""} onClick={() => setGroupNavStyle("card")}>card</button>
                        </div>
                    </div>
                    <div className="sidebar-section">
                        <label>Country</label>
                        <div className="sidebar-buttons">
                            <button className={isSearchableCountry ? "active" : ""} onClick={() => setIsSearchableCountry(true)}>searchable</button>
                            <button className={!isSearchableCountry ? "active" : ""} onClick={() => setIsSearchableCountry(false)}>dropdown</button>
                        </div>
                    </div>
                </div>
                <div className="item-container">
                    <div className={`item-wrapper ${isMultiVariant && variantStyle === "list" ? "variants-layout" : ""}`}>
                        <div className="variants-column">
                            {/* Show message if no variants loaded */}
                            {!loading && productVariants.length === 0 && <p>Items found: 0</p>}
                            {/* grouped section: renders VariantGroups (tabbed) or flat Variants */}
                            {isGrouped ? (
                                <VariantGroups
                                    productVariants={productVariants}
                                    setStyle={variantStyle}
                                    addToBasket={addToBasket}
                                    reduceFromBasket={reduceFromBasket}
                                    checkout={Checkout}
                                    isMultiVariant={isMultiVariant}
                                    fid={basket.id}
                                    groupNavStyle={groupNavStyle}
                                />
                            ) : (
                                <Variants
                                    productVariants={productVariants}
                                    setStyle={variantStyle}
                                    addToBasket={addToBasket}
                                    reduceFromBasket={reduceFromBasket}
                                    checkout={Checkout}
                                    isMultiVariant={isMultiVariant}
                                    fid={basket.id}
                                />
                            )}
                        </div>
                        {isMultiVariant && variantStyle === "list" &&
                            <div className="basket-column">
                                <div
                                    ref={obserRef}
                                    className={`basket-card ${isVisible ? "sticky" : ""}`}>
                                    <Basket basket={basket} />
                                    <div className="item-container">
                                        <div className="item-wrapper">
                                            <button className="btn primary-button" type="submit" onClick={Checkout} disabled={!basket?.lines?.length}>Checkout</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <RelatedOffers offerId={offerId} />
                {/* Fixed mobile basket bar for list multi-variant */}
                {isMultiVariant && variantStyle === "list" &&
                    <div className="mobile-basket-bar">
                        {showMobileBasket && (
                            <div className="mobile-basket-bar-expanded">
                                <Basket basket={basket} />
                                <button className="btn primary-button" onClick={Checkout} disabled={!basket?.lines?.length}>Checkout</button>
                            </div>
                        )}
                        <div className="mobile-basket-bar-content">
                            <span className="mobile-basket-bar-summary">
                                <strong>Order summary</strong> ({basket?.lines?.length || 0} items)
                            </span>
                            <button className="mobile-basket-bar-action" onClick={() => setShowMobileBasket(prev => !prev)} disabled={!basket?.lines?.length}>{showMobileBasket ? "Hide" : "View"}</button>
                        </div>
                    </div>
                }
            </div>  

            {/* WhoIsItFor popup */}
            {showWhoIsItFor && (
                <div className="whoisitfor-overlay">
                    <div className="whoisitfor-popup">
                        <button className="whoisitfor-popup-close" onClick={() => setShowWhoIsItFor(false)}>&times;</button>
                        <WhoIsItFor
                            basket={basket}
                            recipient={recipient}
                            setRecipient={setRecipient}
                            setShowPopup={setShowWhoIsItFor}
                            handleOnSubmit={proceedToCheckout}
                            showPopup={showWhoIsItFor}
                            hideOrderSummary={true}
                        />
                    </div>
                </div>
            )}
          
        </div>
    )

}